module.exports = __webpack_public_path__ + "static/CV_mbf-363d78cd92229a63e365e464c2c41a20.pdf";